import { BOTTOM_TAB } from '../actionTypes';

export const fetchBottomTab = (tab) => ({
  type: BOTTOM_TAB,
  payload: tab,
});
